import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {createOrder, createPaymentIntent} from "../../axios-client";
import {Dialog, DialogContent, DialogTitle, Divider} from "@mui/material";
import {IoClose} from "react-icons/io5";
import StripePaymentButton from "./StripePaymentButton";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import Button from "@mui/material/Button";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { useTranslation } from "react-i18next";

const CreditCardPaymentButton = ({articleId, refreshList, setNotification, cost, processIds}) => {


    const stripePromise = loadStripe(window?.appConfig?.REACT_APP_STRIPE_PUBLIC_KEY || process.env.REACT_APP_STRIPE_PUBLIC_KEY);
    const [clientSecret, setClientSecret] = useState("");
    const [isModalOpen, setModalOpen] = useState(false);
    const options = {
        // passing the client secret obtained from the server
        clientSecret: clientSecret,
    };

    const {t, i18n} = useTranslation(['cardItem']);
    const dir = i18n.dir();
    const marginDirection = dir === "rtl" ? "marginRight" : "marginLeft";
    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleClick = () => {
        createOrder(processIds, 'credit-card')
            .then((res) => {
                setClientSecret(res.data.client_secret)
                setModalOpen(true);
            });
        return false;
    };

    return (
        <>
            <Button
                fullWidth
                variant="outlined"
                style={{
                    background: "linear-gradient(45deg, #0070ba 30%, #003087 90%)",
                    color: "#fff",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                    fontWeight: 500,
                    height:40,
                    py: 1.2,
                    marginTop:"0px !important",
                    fontSize: "0.8rem",
                    backdropFilter: "blur(4px)",
                    "&:hover": {
                        background: "linear-gradient(45deg, #005ea6 30%, #002973 90%)",
                        boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
                    },
                    textTransform:"capitalize"
                }}
                onClick={handleClick}
            >
                Pay with Credit Card
                <CreditCardIcon style={{[marginDirection]: "5px"}}/>
            </Button>
            <Dialog open={isModalOpen} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth
                    PaperProps={{style: {borderRadius: 15}}}>
                <DialogTitle
                    id="form-dialog-title"
                    sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                >
                    {t('payUsingCreditCard',  { cost: cost })}
                    <IoClose
                        aria-label="close"
                        onClick={handleModalClose}
                        style={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            cursor: 'pointer'
                        }}
                    />
                </DialogTitle>
                <Divider/>
                <DialogContent sx={{padding: "0px 24px"}}>

                    <Elements stripe={stripePromise} options={options}>
                        <StripePaymentButton cost={cost}
                                             refreshList={refreshList} setNotification={setNotification}
                        />
                    </Elements>

                </DialogContent>
            </Dialog>


        </>

    );
};

CreditCardPaymentButton.propTypes = {
    articleId: PropTypes.number.isRequired,
    setNotification: PropTypes.func.isRequired,
    refreshList: PropTypes.func,
    stripePromise: PropTypes.string,
    cost: PropTypes.string.isRequired,
    processIds: PropTypes.array
};

export default CreditCardPaymentButton;